module.exports = __webpack_public_path__ + "static/media/S-8-Y.e3769bc3.mp3";